export const stateList = [
    ['Maryland','MD'],
    ['District of Columbia','DC'],
    ['Virginia','VA'],
    ['--------------',''],
    ['Pennsylvania','PA'],
    ['West Virginia','WV'],
    ['Alabama','AL'],
    ['Alaska','AK'],
    ['Arizona','AZ'],
    ['Arkansas','AR'],
    ['California','CA'],
    ['Colorado','CO'],
    ['Connecticut','CT'],
    ['Delaware','DE'],
    ['Florida','FL'],
    ['Georgia','GA'],
    ['Hawaii','HI'],
    ['Idaho','ID'],
    ['Illinois','IL'],
    ['Indiana','IN'],
    ['Iowa','IA'],
    ['Kansas','KS'],
    ['Kentucky','KY'],
    ['Louisiana','LA'],
    ['Maine','ME'],
    ['Massachusetts','MA'],
    ['Michigan','MI'],
    ['Minnesota','MN'],
    ['Mississippi','MS'],
    ['Missouri','MO'],
    ['Montana','MT'],
    ['Nebraska','NE'],
    ['Nevada','NV'],
    ['New Hampshire','NH'],
    ['New Jersey','NJ'],
    ['New Mexico','NM'],
    ['New York','NY'],
    ['North Carolina','NC'],
    ['North Dakota','ND'],
    ['Ohio','OH'],
    ['Oklahoma','OK'],
    ['Oregon','OR'],
    ['Rhode Island','RI'],
    ['South Carolina','SC'],
    ['South Dakota','SD'],
    ['Tennessee','TN'],
    ['Texas','TX'],
    ['Utah','UT'],
    ['Vermont','VT'],
    ['Washington','WA'],
    ['Wisconsin','WI'],
    ['Wyoming','WY'],
    ['American Samoa','AS'],
    ['Federated States of Micronesia','FM'],
    ['Marshall Islands','MH'],
    ['Northern Mariana Islands','MP'],
    ['Palau','PW'],
    ['Puerto Rico','PR'],
    ['Virgin Islands','VI'],
    ['Armed Forces Americas','AA'],
    ['Armed Forces Middle East','AE'],
    ['Armed Forces Pacific','AP']
];

export const medstarEntities = [
    [1,'MedStar Franklin Square Medical Center'],
    [2,'MedStar Georgetown University Hospital'],
    [3,'MedStar Good Samaritan Hospital'],
    [4,'MedStar Harbor Hospital'],
    [5,'MedStar Health Corporate, Shared Services, IS'],
    [6,'MedStar Health Diversified'],
    [7,'MedStar Health Research Institute'],
    [8,'MedStar Medical Group'],
    [9,'MedStar Montgomery Medical Center'],
    [10,'MedStar National Rehabilitation Network'],
    [11,"MedStar St. Mary's Hospital"],
    [12,'MedStar Union Memorial Hospital'],
    [13,'MedStar Washington Hospital Center'],
    [14,'MedStar Southern Maryland Hospital Center']
];
